<template>
  <div>
  <v-form v-model="valid" ref="userMultiCreateForm">
    <v-card-text>
      <v-select v-model="role" :items="roles" item-text="name" item-value="value" :label="`${$t('user.role')}`" required></v-select>
      <v-select  v-model="team" :items="teams" item-text="name" item-value="id" :label="`${$t('user.team')}`"></v-select>
      <v-select v-model="department" :items="departments" item-text="name" item-value="id" :label="`${$t('department.name')}`" required></v-select>
      <v-select v-model="agency" :items="agencies" item-text="name" item-value="id" :label="`${$t('agency.agency')}`" required></v-select>
      <v-text-field :label="`${$t('archive.choose_file')}`" @click="onPickFile" v-model='fileName' prepend-icon="attach_file"></v-text-field>
      <input type="file" style="display: none" ref="fileInput" :accept="getAllowedExtension()" @change="onFilePicked">
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-progress-circular indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-circular>
      <v-btn color="primary" @click="create" :disabled="loading">
        {{ $t('base.create') }}
      </v-btn>
    </v-card-actions>
  </v-form>
    <v-container>
      <div>
        <h4>Instrukcja. Mapowanie kolumn:</h4>
        <ul>
          <li>Login - 1</li>
          <li>Email - 2</li>
          <li>Imie - 3</li>
          <li>Nazwisko - 4</li>
          <li>Język - 5</li>
          <li>Hasło - 6</li>
        </ul>
      </div>
    </v-container>
  </div>
</template>

<script>
import Acl from "@/plugins/Acl"
import Messenger from "@/plugins/Messenger";
export default {
  name: "MultiForm",
  props:['agencies','roles','departments'],
  data() {
    return {
      acl: new Acl(),
      file: null,
      fileName: "",
      loading: false,
      agency: null,
      department: null,
      team: null,
      role: null,
      valid: false


    }
  },
  computed: {
    teams() {
      return [{
        id: null,
        name: this.$t('user.create.no-team')
      }].concat(this.$store.state.teams).filter(team => team.assign_hidden == 0)
    }
  },
  methods:{
    create(){
      if (this.$refs.userMultiCreateForm.validate()) {
        this.loading = true

        this.$http.post("user/create-multi", this.getFormData()).then(() => {
          this.loading = false
          this.$store.commit("setSnack", {
            message: this.$t("user.create.success-message", {
              username: this.username
            }),
            color: "success"
          })
          this.$emit("exit")
        }).catch(()=>{
          Messenger.emitError("Error")
          this.loading = false
        })
      }
    },
    getFormData(){
      let formData = new FormData()
      formData.append('role', this.role)
      formData.append('team_id', this.team)
      formData.append('department_id', this.department)
      formData.append('agency_id', this.agency)
      formData.append('file', this.file)
      return formData

    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {

        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }

        if(files[0].name.split('.').pop() != this.getAllowedExtension()){
          return Messenger.emitError(this.$t('user.create.error.wrong-extension'))
        }

        this.fileName = files[0].name
        this.file = files[0]

      } else {
        this.fileName = undefined
        this.file = undefined
      }
    },
    getAllowedExtension() {
      return 'csv'
    }
  }
}
</script>

<style scoped>

</style>